export interface ReportDownloadListResponse {
  id: string
  fileUrl?: string
  createdAt: string
}

export class ReportDownloadListModel {
  public id: string
  public fileUrl?: string
  public createdAt: string

  public constructor(data: ReportDownloadListResponse) {
    this.id = data.id
    this.fileUrl = data.fileUrl
    this.createdAt = data.createdAt
  }
}
